import { LuDot } from "react-icons/lu";
import { RiEditFill } from "react-icons/ri";
import Skeleton from "react-loading-skeleton";
import { MdDeleteSweep } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { HiDotsVertical } from "react-icons/hi";
import { IoCloseCircle } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import { BsArrowUpCircle } from "react-icons/bs";
import SkeletonOne from "../skeleton/SkeletonOne";
import { Drawer } from "@material-tailwind/react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BiSolidMessage, BiSolidReport } from "react-icons/bi";
import { FaHeart, FaRegComment, FaRegHeart, FaUserSlash } from "react-icons/fa";
import { GetComment, likeDislikeComment, likeDislikeCommentReply } from "../../redux/ApiSlice/CommentsSlice";

export default function Comments(props) {
    const {
        postId,
        openBottomComments,
        comments_enabled,
        closeDrawerBottomCommments,
        // comments=[],
        handleChangeComment,
        commentPrev,
        handleChangeReply,
        menuCommentId,
        emptyComments,
        menuRef,
        created_by,
        handleChangeEditComment,
        handleUpdateCommentReply,
        toggleMenu,
        handleChangeDeleteComment,
        setMenuCommentId,
        originalURL,
        createCommet,
        handleSubmitComment,
        handleChangeRepleyComment,
        handleEditReply,
        handleUpdateNestedReply,
        editNestedReply,
        editReply,
        repleyitemId,
        handleOpenreplay,
        replay,
        setReplay,
        setReportModal,
        handleSubmitReplay,
        createReplay,
        handleCloseReply,
        EditComment,
        closeEditComment,
        getCommentRepliesByCommentId,
        replyDelete,
        deleteNestedReply,
        commentsData,
        setCommentsData,
        setBlockUser,
    } = props;

    const inputRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const post_created_by = created_by;
    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const { User_profile } = ProfileDetails;
    const comments = useSelector((state) => state.comments);
    // const [commentsData, setCommentsData] = useState([])
    const [menuReplyId, setMenuReplyId] = useState(null);
    const [showReplies, setShowReplies] = useState(false);
    const [replyData, setReplyData] = useState([]);

    const [page, setPage] = useState(1); // Current page
    const [hasMore, setHasMore] = useState(null); // Whether more comments are available
    const scrollRef = useRef(null);

    const stopScrollEventPropagation = (event) => {
        event.stopPropagation();
    };

    // Fetch comments when the component mounts or page changes
    useEffect(() => {
        // if (comments.nextPage === null) {
        if (postId && comments_enabled) {
            if (openBottomComments) {
                fetchComments(page);
            }
        }
        if (!openBottomComments) {
            setCommentsData([]);
        }
    }, [page, postId, openBottomComments]);

    const fetchComments = async (page) => {
        try {
            if (page == 1) {
                setCommentsData([]); // Clear previous comments when fetching the first page
            }
            const response = await dispatch(GetComment({ id: postId, page })); // Replace `getComments` with your API action
            if (response.payload) {
                setCommentsData((prev) => [
                    ...prev,
                    ...response.payload.results.comments,
                ]);
                setHasMore(response.payload.next); // Check if there's a next page
            } else {
                setHasMore(false); // No more comments to load
            }
        } catch (error) {
            console.error("Error fetching comments:", error);
        }
    };
    const focusInput = () => {
        inputRef.current.focus();
    };

    const handleGoAccount = (UserId) => {
        if (User_profile.id === UserId) {
            navigate(`/account`);
        } else {
            navigate(`/account/${UserId}`);
        }
    };

    const reportComment = (commentId) => {
        closeDrawerBottomCommments();
        setReportModal(commentId);
    };

    const handleBlockUser = (user) => {
        setBlockUser(user);
        setMenuCommentId(null);
        setMenuReplyId(null);
    };

    function timeAgo(timestamp) {
        const now = new Date();
        const past = new Date(timestamp);
        const seconds = Math.floor((now - past) / 1000);

        const intervals = {
            year: 31536000, // 60 * 60 * 24 * 365
            month: 2592000, // 60 * 60 * 24 * 30
            day: 86400, // 60 * 60 * 24
            hour: 3600, // 60 * 60
            minute: 60,
            second: 1,
        };

        for (const key in intervals) {
            const interval = Math.floor(seconds / intervals[key]);
            if (interval >= 1) {
                return `${interval}${key[0]} ago`;
            }
        }

        // Always show at least 1 second instead of "just now"
        return "1s ago";
    }

    useEffect(() => {
        setReplyData(comments?.commentReplies);
    }, [comments]);

    useEffect(() => {
        if (replay) {
            focusInput();
        }
        if (menuCommentId) {
            window.scrollTo(0, 0);
        }
        // return () => setReplay(false);
    }, [replay, menuCommentId, setReplay]);

    // NEW DESIGN FOR COMMENTS
    const [likedComments, setLikedComments] = useState([]);

    const handleLike = (commentId) => {
        setLikedComments((prev) =>
            prev.includes(commentId)
                ? prev.filter((id) => id !== commentId)
                : [...prev, commentId]
        );
    };

    const handleLikeDislikeComment = async (commentId) => {
        try {
            const response = await dispatch(likeDislikeComment({ commentId }));
            if (response.payload) {
                setCommentsData((prevComments) =>
                    prevComments.map((comment) => {
                        if (comment.id === commentId) {
                            return {
                                ...comment,
                                is_liked: response.payload.is_liked,
                                like_count: comment.is_liked ? 1 - 1 : 1,
                            };
                        }
                        return comment;
                    })
                );
            }
        } catch (error) {
            console.error("Error liking/disliking comment:", error);
        }
    };
    const handleLikeDislikeCommentReply = async (replyId) => {
        try {
            const response = await dispatch(likeDislikeCommentReply({ replyId }));
            if (response.payload) {
                setReplyData((prevComments) => {
                    return prevComments.map((comment) => {
                        if (comment.id === replyId) {
                            return {
                                ...comment,
                                is_liked: response.payload.is_liked,
                                like_count: comment.is_liked ? 1 - 1 : 1,
                            };
                        }
                        return comment;
                    });
                });
            }
        } catch (error) {
            console.error("Error liking/disliking comment:", error);
        }
    };

    const handleShowReplies = (commentId) => {
        setShowReplies((prevId) => (prevId === commentId ? null : commentId));
        if (showReplies !== commentId) {
            getCommentRepliesByCommentId(commentId);
        }
    };

    const toggleMenus = (commentId, e) => {
        if (e) e.stopPropagation();
        setMenuCommentId(menuCommentId === commentId ? null : commentId);
    };

    const toggleReplyMenu = (replyId) => {
        setMenuReplyId(menuReplyId === replyId ? null : replyId);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuReplyId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuRef]);

    // Handle scroll event to detect when the user reaches the bottom
    const handleScroll = () => {
        if (comments.loading || !scrollRef.current) {
            return; // Exit if loading or ref is not available
        }

        const div = scrollRef.current;

        if (comments.loading) {
            return; // Exit if loading
        }
        if (!div) {
            return; // Exit if the ref is null
        }
        const { scrollTop, scrollHeight, clientHeight } = div;
        if (
            scrollTop + clientHeight >= scrollHeight - 5 &&
            hasMore &&
            !comments.loading
        ) {
            setPage((prevPage) => prevPage + 1);
        }
    };

    const handleCommentKeyDown = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            handleSubmitComment();
        }
    };

    const handleReplyKeyDown = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            if (editNestedReply) {
                handleUpdateNestedReply();
            } else if (editReply) {
                handleUpdateCommentReply();
            } else {
                handleSubmitReplay(showReplies);
            }
        }
    };

    return (
        <Drawer
            placement="bottom"
            open={openBottomComments}
            onClose={closeDrawerBottomCommments}
            size={window.innerWidth < 500 ? 320 : 300}
            className={`absolute w-full rounded-t-xl ${!openBottomComments && "hidden"}`}
        >
            <div className="h-full w-full bg-white dark:bg-[#1E1D21] rounded-t-xl pb-10 overflow-hidden">
                <div
                    ref={scrollRef}
                    onScroll={handleScroll}
                    onTouchStartCapture={stopScrollEventPropagation}
                    onTouchMoveCapture={stopScrollEventPropagation}
                    onWheelCapture={stopScrollEventPropagation}
                    className="bg-white dark:bg-[#1E1D21] dark:text-white rounded-t-xl pt-0 w-full h-full overflow-y-scroll no-scrollbar touch-pan-y overscroll-contain"
                >
                    {comments.loading && <SkeletonOne />}
                    {!comments.loading && commentsData?.length !== 0 && (
                        <div className="w-full">
                            {commentsData?.map((data) => {
                                return (
                                    <div key={data?.id}>
                                        <div className="py-2 px-2 border-b border-gray-300 dark:border-gray-800/50 relative">
                                            <div className="flex items-start">
                                                <div className="h-7 w-10">
                                                    <img
                                                        alt="profile"
                                                        src={data?.created_by?.avatar_url}
                                                        onClick={() =>
                                                            handleGoAccount(data?.created_by?.id)
                                                        }
                                                        className="h-7 w-7 rounded-full object-cover bg-gray-300 dark:bg-gray-800 cursor-pointer"
                                                    />
                                                </div>
                                                <div className="flex flex-col w-full">
                                                    <div className="flex items-start justify-between">
                                                        <div
                                                            className="flex items-start gap-x-2 relative"
                                                            onClick={() => handleChangeRepleyComment(data)}
                                                        >
                                                            <div className="flex flex-col">
                                                                <p
                                                                    onClick={() =>
                                                                        handleGoAccount(data?.created_by?.id)
                                                                    }
                                                                    className="text-[14px] font-bold line-clamp-1 cursor-pointer"
                                                                >
                                                                    {data?.created_by?.full_name}
                                                                </p>
                                                                <div className="flex items-center gap-x-[1px]">
                                                                    {post_created_by?.id ===
                                                                        data?.created_by?.id && (
                                                                            <LuDot className="text-[10px] text-gray-500" />
                                                                        )}
                                                                    <p className="text-[8px] text-gray-500 line-clamp-1">
                                                                        {post_created_by?.id ===
                                                                            data?.created_by?.id && "Author"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <HiDotsVertical
                                                                onClick={(e) => toggleMenus(data?.id, e)}
                                                                className="text-[12px] cursor-pointer text-gray-600 mt-[3px]"
                                                            />
                                                            {menuCommentId === data?.id && (
                                                                <div
                                                                    ref={menuRef}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    className="absolute top-0 -right-14 w-auto bg-white dark:bg-[#1E1D21] border-2 border-indigo-100 overflow-hidden rounded shadow-lg"
                                                                >
                                                                    <p
                                                                        onClick={() =>
                                                                            handleChangeRepleyComment(data)
                                                                        }
                                                                        className="px-1.5 py-[1px] text-[8px] text-gray-700 dark:text-white dark:hover:bg-[#444444] dark:hover:text-white cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                    >
                                                                        <BiSolidMessage className="mt-[2px]" />
                                                                        Reply
                                                                    </p>
                                                                    {User_profile?.id !== data?.created_by?.id && (
                                                                        <p
                                                                            onClick={() => reportComment(data?.id)}
                                                                            className="px-1.5 py-[1px] text-[8px] text-gray-700 dark:text-white dark:hover:bg-[#444444] dark:hover:text-white cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                        >
                                                                            <BiSolidReport className="mt-[-0.5px]" />
                                                                            Report
                                                                        </p>
                                                                    )}
                                                                    {User_profile?.id !== data?.created_by?.id && (
                                                                        <p
                                                                            onClick={() => handleBlockUser(data?.created_by)}
                                                                            className="px-1.5 py-[1px] text-[8px] text-gray-700 dark:text-white dark:hover:bg-[#444444] dark:hover:text-white cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                        >
                                                                            <FaUserSlash className="mt-[-0.5px]" />
                                                                            Block
                                                                        </p>
                                                                    )}
                                                                    {User_profile?.id ===
                                                                        data?.created_by?.id && (
                                                                            <>
                                                                                <p
                                                                                    onClick={() =>
                                                                                        handleChangeEditComment(data)
                                                                                    }
                                                                                    className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                                >
                                                                                    <RiEditFill /> Edit
                                                                                </p>
                                                                                <p
                                                                                    onClick={() =>
                                                                                        handleChangeDeleteComment(data?.id)
                                                                                    }
                                                                                    className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                                >
                                                                                    <MdDeleteSweep className="mt-[-1px]" />{" "}
                                                                                    Delete
                                                                                </p>
                                                                            </>
                                                                        )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <p className="text-[10px] w-[80%] mt-0.5 break-words leading-[14px]">
                                                        {data?.post_comment_box}
                                                    </p>

                                                    <div className="flex items-center justify-between mt-1">
                                                        <div className="flex items-center gap-x-2">
                                                            <p className="text-[10px] font-semibold text-gray-500 line-clamp-1">
                                                                {timeAgo(data?.created_at)}
                                                            </p>
                                                            <p
                                                                onClick={() => handleChangeRepleyComment(data)}
                                                                className="text-[10px] font-semibold text-gray-700 cursor-pointer"
                                                            >
                                                                Reply
                                                            </p>
                                                        </div>
                                                        <div
                                                            onClick={() => handleLikeDislikeComment(data?.id)}
                                                            className="flex items-center gap-x-1 w-5"
                                                        >
                                                            <p className="text-[10px] font-semibold text-gray-500">
                                                                {data?.like_count}
                                                            </p>
                                                            {data?.is_liked ? (
                                                                <FaHeart className={`text-[10px] ${data?.is_liked ? "text-red-800" : "text-gray-600"} cursor-pointer`} />
                                                            ) : (
                                                                <FaRegHeart className={`text-[10px] ${data?.is_liked ? "text-red-800" : "text-gray-600"} cursor-pointer`} />
                                                            )}
                                                        </div>
                                                    </div>

                                                    {data?.reply_count > 0 &&
                                                        <div
                                                            onClick={() => handleShowReplies(data.id)}
                                                            className="flex items-center gap-x-1 mt-1.5"
                                                        >
                                                            <IoIosArrowDown
                                                                className={`text-[14px] text-gray-700 cursor-pointer transform ${showReplies === data.id ? "rotate-180" : "rotate-0"} transition-transform duration-200`}
                                                            />
                                                            <p className="text-[10px] font-semibold text-gray-700 cursor-pointer">
                                                                {showReplies === data.id ?
                                                                    "Close replies" :
                                                                    `View ${data?.reply_count ? `${data?.reply_count}` : null} ${data?.reply_count === 1 ? "reply" : "replies"}`
                                                                }
                                                            </p>
                                                        </div>
                                                    }

                                                    {data?.reply_count > 0 && showReplies === data.id && (
                                                        <div className="h-[0.5px] bg-gray-300 dark:bg-gray-800 w-[86%] mt-1.5" />
                                                    )}

                                                    {comments?.replyLoading && showReplies === data.id
                                                        ? [1, 2, 3, 4, 5, 7, 8, 9].map((item) => (
                                                            <div
                                                                className="grid grid-cols-12  py-1"
                                                                key={item}
                                                            >
                                                                <div className="col-span-2 flex justify-start items-center">
                                                                    <Skeleton
                                                                        height={30}
                                                                        width={30}
                                                                        circle={true}
                                                                    />
                                                                </div>
                                                                <div className="col-span-4 -ml-3">
                                                                    <Skeleton height={15} width={150} />
                                                                    <Skeleton height={15} width={100} />
                                                                </div>
                                                            </div>
                                                        ))
                                                        : null
                                                    }
                                                    {showReplies === data.id &&
                                                        replyData?.map((reply) => (
                                                            <>
                                                                <div
                                                                    key={reply.id}
                                                                    className="flex w-full mt-1.5"
                                                                >
                                                                    <div className="h-7 w-10">
                                                                        <img
                                                                            alt="User"
                                                                            src={reply.created_by.avatar_url}
                                                                            onClick={() =>
                                                                                handleGoAccount(reply.created_by.id)
                                                                            }
                                                                            className="h-7 w-7 object-cover rounded-full cursor-pointer bg-gray-300 dark:bg-gray-800"
                                                                        />
                                                                    </div>
                                                                    <div className="flex items-start justify-between w-full">
                                                                        <div className="flex flex-col w-fit">
                                                                            <div className="flex items-start gap-x-2 relative">
                                                                                <p className="text-[11px] font-bold line-clamp-1">
                                                                                    {reply.created_by.full_name}
                                                                                </p>
                                                                                <HiDotsVertical
                                                                                    onClick={() =>
                                                                                        toggleReplyMenu(reply?.id)
                                                                                    }
                                                                                    className="text-[12px] cursor-pointer text-gray-600 mt-0.5"
                                                                                />
                                                                                {menuReplyId === reply?.id && (
                                                                                    <div
                                                                                        ref={menuRef}
                                                                                        className="absolute top-0 -right-12 w-auto bg-white border border-gray-400 overflow-hidden rounded shadow-lg"
                                                                                    >
                                                                                        <p
                                                                                            onClick={() =>
                                                                                                handleChangeRepleyComment(
                                                                                                    reply,
                                                                                                    true
                                                                                                )
                                                                                            }
                                                                                            className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                                        >
                                                                                            <BiSolidMessage className="mt-[2px]" />{" "}
                                                                                            Reply
                                                                                        </p>
                                                                                        {reply.created_by.id ===
                                                                                            User_profile.id && (
                                                                                                <p
                                                                                                    onClick={() =>
                                                                                                        handleEditReply(reply)
                                                                                                    }
                                                                                                    className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                                                >
                                                                                                    <RiEditFill className="mt-[2px]" />{" "}
                                                                                                    Edit
                                                                                                </p>
                                                                                            )}
                                                                                        {reply.created_by.id ===
                                                                                            User_profile.id && (
                                                                                                <p
                                                                                                    onClick={() =>
                                                                                                        replyDelete(reply.id, data.id)
                                                                                                    }
                                                                                                    className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                                                >
                                                                                                    <MdDeleteSweep className="mt-[-1px]" />{" "}
                                                                                                    Delete
                                                                                                </p>
                                                                                            )}
                                                                                        {reply.created_by.id !==
                                                                                            User_profile.id && (
                                                                                                <>
                                                                                                    <p
                                                                                                        onClick={() => handleBlockUser(reply.created_by)}
                                                                                                        className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                                                    >
                                                                                                        <FaUserSlash className="mt-[-0.5px]" />
                                                                                                        Block
                                                                                                    </p>
                                                                                                    <p className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap">
                                                                                                        <BiSolidReport className="mt-[-0.5px]" />{" "}
                                                                                                        Report
                                                                                                    </p>
                                                                                                </>
                                                                                            )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <div className="flex items-center gap-x-[1px]">
                                                                                <p className="text-[8px] mt-[-2px] text-gray-500 line-clamp-1">
                                                                                    {timeAgo(reply.created_at)}
                                                                                </p>
                                                                                {reply.created_by.id ===
                                                                                    data?.created_by?.id && (
                                                                                        <LuDot className="text-[10px] text-gray-500" />
                                                                                    )}
                                                                                <p className="text-[8px] mt-[-2px] text-gray-500 line-clamp-1">
                                                                                    {reply.created_by.id === data?.created_by?.id && "Commenter"}
                                                                                </p>
                                                                            </div>
                                                                            <p className="text-[10px] mt-[3px] break-words leading-[14px]">
                                                                                {reply.post_comment_box}
                                                                            </p>
                                                                        </div>
                                                                        <div className="flex items-center gap-x-3 mt-[3px]">
                                                                            <div
                                                                                className="flex flex-col items-center w-3"
                                                                                onClick={() => handleLikeDislikeCommentReply(reply?.id)}
                                                                            >
                                                                                {reply.is_liked ?
                                                                                    <FaHeart className={`text-[10px] ${reply.is_liked ? "text-red-800" : "text-gray-600"} cursor-pointer`} />
                                                                                    :
                                                                                    <FaRegHeart className={`text-[10px] ${reply.is_liked ? "text-red-800" : "text-gray-600"} cursor-pointer`} />
                                                                                }
                                                                                <p className="text-[8px] text-gray-500">
                                                                                    {reply.like_count}
                                                                                </p>
                                                                            </div>
                                                                            <div className="flex flex-col items-center w-3">
                                                                                <FaRegComment className="text-[10px] text-gray-600 cursor-pointer" />
                                                                                <p className="text-[8px] text-gray-500">
                                                                                    0
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {reply.nested_replies?.length > 0 &&
                                                                    reply.nested_replies.map((nestedReply) => (
                                                                        <div
                                                                            key={nestedReply?.id}
                                                                            className="flex w-full mt-1.5 pl-8"
                                                                        >
                                                                            <div className="h-7 w-10">
                                                                                <img
                                                                                    alt="User"
                                                                                    src={
                                                                                        nestedReply?.created_by.avatar_url
                                                                                    }
                                                                                    onClick={() =>
                                                                                        handleGoAccount(
                                                                                            nestedReply?.created_by.id
                                                                                        )
                                                                                    }
                                                                                    className="h-7 w-7 object-cover rounded-full cursor-pointer bg-gray-300 dark:bg-gray-800"
                                                                                />
                                                                            </div>
                                                                            <div className="flex items-start justify-between w-full">
                                                                                <div className="flex flex-col w-fit">
                                                                                    <div className="flex items-start gap-x-2 relative">
                                                                                        <p className="text-[11px] font-bold line-clamp-1">
                                                                                            {nestedReply?.created_by.full_name}
                                                                                        </p>
                                                                                        <HiDotsVertical
                                                                                            onClick={() =>
                                                                                                toggleReplyMenu(nestedReply?.id)
                                                                                            }
                                                                                            className="text-[12px] cursor-pointer text-gray-600 mt-0.5"
                                                                                        />
                                                                                        {menuReplyId ===
                                                                                            nestedReply?.id && (
                                                                                                <div
                                                                                                    ref={menuRef}
                                                                                                    className="absolute top-0 -right-12 w-auto bg-white border border-gray-400 overflow-hidden rounded shadow-lg"
                                                                                                >
                                                                                                    {nestedReply?.created_by?.id ===
                                                                                                        User_profile.id && (
                                                                                                            <p
                                                                                                                onClick={() =>
                                                                                                                    handleEditReply(
                                                                                                                        nestedReply,
                                                                                                                        true
                                                                                                                    )
                                                                                                                }
                                                                                                                className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                                                            >
                                                                                                                <RiEditFill className="mt-[2px]" />{" "}
                                                                                                                Edit
                                                                                                            </p>
                                                                                                        )}
                                                                                                    {nestedReply?.created_by?.id ===
                                                                                                        User_profile.id && (
                                                                                                            <p
                                                                                                                onClick={() =>
                                                                                                                    deleteNestedReply(
                                                                                                                        nestedReply?.id,
                                                                                                                        data.id
                                                                                                                    )
                                                                                                                }
                                                                                                                className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                                                            >
                                                                                                                <MdDeleteSweep className="mt-[-1px]" />{" "}
                                                                                                                Delete
                                                                                                            </p>
                                                                                                        )}
                                                                                                    {nestedReply?.created_by?.id !==
                                                                                                        User_profile.id && (
                                                                                                            <>
                                                                                                                <p
                                                                                                                    onClick={() => handleBlockUser(nestedReply?.created_by)}
                                                                                                                    className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap"
                                                                                                                >
                                                                                                                    <FaUserSlash className="mt-[-0.5px]" />
                                                                                                                    Block
                                                                                                                </p>
                                                                                                                <p className="px-1.5 py-[1px] text-[8px] text-gray-700 hover:bg-gray-300 hover:text-black cursor-pointer flex items-center gap-x-1 whitespace-nowrap">
                                                                                                                    <BiSolidReport className="mt-[-0.5px]" />{" "}
                                                                                                                    Report
                                                                                                                </p>
                                                                                                            </>
                                                                                                        )}
                                                                                                </div>
                                                                                            )}
                                                                                    </div>
                                                                                    <div className="flex items-center gap-x-[1px]">
                                                                                        <p className="text-[8px] mt-[-2px] text-gray-500 line-clamp-1">
                                                                                            {timeAgo(nestedReply?.created_at)}
                                                                                        </p>
                                                                                        {nestedReply?.created_by.id ===
                                                                                            data?.created_by?.id && (
                                                                                                <LuDot className="text-[10px] text-gray-500" />
                                                                                            )}
                                                                                        <p className="text-[8px] mt-[-2px] text-gray-500 line-clamp-1">
                                                                                            {nestedReply?.created_by.id ===
                                                                                                data?.created_by?.id &&
                                                                                                "Commenter"}
                                                                                        </p>
                                                                                    </div>
                                                                                    <p className="text-[10px] mt-[3px] break-words leading-[14px]">
                                                                                        {nestedReply?.post_comment_box}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                            </>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {!comments.loading && commentsData?.length === 0 && (
                        <div className="flex flex-col justify-center items-center">
                            <p className="text-[12px] text-gray-600 dark:text-gray-500 mt-20">
                                No comments. Be the first to comment!
                            </p>
                        </div>
                    )}
                </div>

                {!repleyitemId ? (
                    EditComment ? (
                        <div className="px-2 absolute bottom-[4px] z-50 flex flex-col bg-white dark:bg-black w-full pt-1 border-t border-gray-300 dark:border-gray-800">
                            <p className="text-[10px] text-blue-700 font-bold">
                                Edit your Comment
                            </p>
                            <div className="py-2 w-full  relative">
                                <div className="flex items-start">
                                    <div className="h-7 w-10">
                                        <img
                                            alt="profile"
                                            src={commentPrev?.created_by?.avatar_url}
                                            onClick={() =>
                                                handleGoAccount(commentPrev?.created_by?.id)
                                            }
                                            className="h-7 w-7 rounded-full object-cover bg-gray-300 dark:bg-gray-800"
                                        />
                                    </div>
                                    <div className="flex flex-col w-full">
                                        <div className="flex items-start justify-between">
                                            <div className="flex flex-col items-start gap-x-2 relative w-full">
                                                <div className="flex flex-col w-full">
                                                    <div className="flex justify-between items-center w-full">
                                                        <p
                                                            onClick={() =>
                                                                handleGoAccount(commentPrev?.created_by?.id)
                                                            }
                                                            className="text-[11px] font-bold line-clamp-1 cursor-pointer text-black dark:text-white"
                                                        >
                                                            {commentPrev?.created_by?.full_name}
                                                        </p>
                                                        <IoCloseCircle
                                                            onClick={closeEditComment}
                                                            className="text-gray-500 cursor-pointer text-[18px] hover:text-gray-700"
                                                        />
                                                    </div>
                                                    <p className="text-[8px] text-gray-500 mt-[-2px] line-clamp-1">
                                                        {timeAgo(commentPrev.created_at)}
                                                    </p>
                                                </div>
                                                <p className="text-[10px] mt-[3px] break-words leading-[14px] text-black dark:text-white">
                                                    {commentPrev?.post_comment_box}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full z-50  flex">
                                <div className="h-8 w-11">
                                    <img
                                        alt="profile"
                                        src={originalURL}
                                        className="h-8 w-8 rounded-full object-cover bg-gray-300 dark:bg-gray-800"
                                    />
                                </div>
                                <div className="flex justify-start w-full relative">
                                    <input
                                        type="text"
                                        ref={inputRef}
                                        value={createCommet.body}
                                        onChange={handleChangeComment}
                                        onKeyDown={handleCommentKeyDown}
                                        placeholder="your Reply"
                                        className="text-[14px] bg-gray-200 w-full text-[#000] pl-2 pr-7 py-1 outline-none rounded placeholder:text-[14px]"
                                    />
                                    <BsArrowUpCircle
                                        onClick={handleSubmitComment}
                                        className="absolute right-1 w-5 top-[3px] text-blue-600 hover:text-blue-700 text-[22px] cursor-pointer"
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="px-2 absolute bottom-1 pt-1 z-50 flex items-center w-full bg-white dark:bg-[#1E1D21] border-t border-gray-300 dark:border-gray-800/50">
                            <div className="h-8 w-11">
                                <img
                                    alt="profile"
                                    src={originalURL}
                                    className="h-8 w-8 rounded-full object-cover bg-gray-300 dark:bg-gray-800"
                                />
                            </div>
                            <div className="flex justify-start w-full relative">
                                <input
                                    type="text"
                                    ref={inputRef}
                                    value={createCommet.body}
                                    onChange={handleChangeComment}
                                    onKeyDown={handleCommentKeyDown}
                                    placeholder="Type your comment"
                                    className="text-[14px] w-full py-2 bg-gray-200 dark:bg-[#333333] text-black dark:text-white pl-2 pr-10 focus:outline-none rounded-md border-none"
                                />
                                <button
                                    onClick={handleSubmitComment}
                                    className="absolute top-1 right-1 bg-[#BDE6FF] flex items-center justify-center h-[30px] w-[30px] rounded-full cursor-pointer z-50 disabled:opacity-50"
                                >
                                    <BsArrowUpCircle className="text-[20px] text-black" />
                                </button>
                            </div>
                        </div>
                    )
                ) : (
                    <div className="px-2 absolute bottom-[4px] z-50 flex flex-col bg-white dark:bg-[#1E1D21] w-full pt-1.5 border-t border-gray-300 dark:border-gray-800/50">
                        <div className="pb-2 w-full relative">
                            <div className="flex items-start">
                                <div className="h-7 w-10">
                                    <img
                                        alt="profile"
                                        src={commentPrev?.created_by?.avatar_url}
                                        onClick={() => handleGoAccount(commentPrev?.created_by?.id)}
                                        className="h-7 w-7 rounded-full object-cover bg-gray-300 dark:bg-[#333333]"
                                    />
                                </div>
                                <div className="flex flex-col w-full">
                                    <div className="flex items-start justify-between">
                                        <div className="flex flex-col items-start gap-x-2 relative w-full">
                                            <div className="flex flex-col w-full">
                                                <div className="flex justify-between items-center w-full">
                                                    <p
                                                        onClick={() =>
                                                            handleGoAccount(commentPrev?.created_by?.id)
                                                        }
                                                        className="text-[11px] font-bold line-clamp-1 cursor-pointer text-black dark:text-white"
                                                    >
                                                        {commentPrev?.created_by?.full_name}
                                                    </p>
                                                    <IoCloseCircle
                                                        onClick={handleCloseReply}
                                                        className="text-gray-500 cursor-pointer text-[18px] hover:text-gray-700"
                                                    />
                                                </div>
                                                <p className="text-[8px] text-gray-500 mt-[-2px] line-clamp-1">
                                                    {timeAgo(commentPrev.created_at)}
                                                </p>
                                            </div>
                                            <p className="text-[10px] mt-[3px] break-words leading-[14px] text-black dark:text-white">
                                                {commentPrev?.post_comment_box}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full z-50 flex">
                            <div className="h-8 w-11">
                                <img
                                    alt="profile"
                                    src={originalURL}
                                    className="h-8 w-8 rounded-full object-cover bg-gray-300 dark:bg-[#333333]"
                                />
                            </div>
                            <div className="flex justify-start w-full relative">
                                <input
                                    type="text"
                                    ref={inputRef}
                                    value={createReplay.body}
                                    onChange={handleChangeReply}
                                    onKeyDown={handleReplyKeyDown}
                                    placeholder="Type your Reply"
                                    className="text-[14px] bg-gray-200 dark:bg-[#333333] w-full text-black dark:text-white pl-2 pr-7 py-1 outline-none rounded placeholder:text-[14px]"
                                />
                                <BsArrowUpCircle
                                    onClick={() =>
                                        editNestedReply
                                            ? handleUpdateNestedReply()
                                            : editReply
                                                ? handleUpdateCommentReply()
                                                : handleSubmitReplay(showReplies)
                                    }
                                    className="absolute right-1 w-5 top-[3px] text-blue-600 hover:text-blue-700 text-[22px] cursor-pointer"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Drawer>
    );
}
